import { render, staticRenderFns } from "./updateTemplate.vue?vue&type=template&id=cafe8520&scoped=true"
import script from "./updateTemplate.vue?vue&type=script&lang=js"
export * from "./updateTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafe8520",
  null
  
)

export default component.exports